import JdsModal from "../JdsModal";

//Jds

import {
  ActionButton,
  Button,
  Container,
  Icon,
  InputDate,
  InputDropdown,
  InputField,
  ListBlock,
  Text,
} from "@jds/core";

const SuccessModal = (props) => {
  const { subtitle } = props;
  return (
    <JdsModal header="" size="m" kind="informational" close={true} {...props}>
      <Container
        direction="column"
        style={{ alignItems: "center", width: "100%" }}
        fullWidth
        gap={16}
      >
        <Icon ic={"IcSuccessColored"} kind="background" size="xxl" />
        <Text
          color="primary_grey_100"
          appearance="heading-xs"
          text="Congratulations!"
        />
        <Text
          color="primary_grey_80"
          appearance="body_m"
          text={subtitle || "Your event has been created successfully."}
        />
        <Container style={{ marginTop: "32px" }} fullWidth>
          <Button
            component="label"
            label={props.btnText}
            kind="primary"
            size="medium"
            fullWidth
            onClick={() => {
              props?.btnAction();
            }}
          />
        </Container>
      </Container>
    </JdsModal>
  );
};

export default SuccessModal;
